var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-chip",class:{'app-chip--dark': _vm.dark},style:({'background-color': _vm.color})},[_c('span',{staticClass:"app-chip_label unselectable"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }